import { render, staticRenderFns } from "./BusinessRegistry.vue?vue&type=template&id=26a64dfd&scoped=true&"
import script from "./BusinessRegistry.vue?vue&type=script&lang=js&"
export * from "./BusinessRegistry.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRegistry.vue?vue&type=style&index=0&id=26a64dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a64dfd",
  null
  
)

export default component.exports